import React, { useEffect, useRef } from 'react';
import CommonTile from '../component/commonTile'
import './index.less'
import RcQueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';
export default function Top1() {
  
  return <div className='product'>
    <OverPack playScale={0.15}>
      <RcQueueAnim type={'top'}>
        <div key={1}>
          <CommonTile title="核心能力" bottom={20}/>
        </div>
      </RcQueueAnim>
      <div className='inner product-inner'>
        <RcQueueAnim type={'top'}>
          <div key={1} className='product-text'>
            <p>可信数据空间</p>
            <p>跨越行业界限,提供安全可靠的大规模全流程数据服务。结合智能经济体系,量身打造创新金融解决方案</p>
            <p>以区块链共创未来无限可能</p>
          </div>
        </RcQueueAnim>
        <RcQueueAnim type={'scale'}>
          <div key={1} className='product-ability'></div>
        </RcQueueAnim>
      </div>
    </OverPack>
  </div>
}
